export default "__VITE_ASSET__P8pIKoGU__"